export default [
  {
    path: "/procurement/committees",
    name: "procurement-committees",
    meta: {
      title: "Procurement Committees",
      authRequired: true,
      privileges: [],
    },
    component: () => import("@/views/committees/ProcurementCommittees.vue"),
  },
  {
    path: "/procurement/committee-approvals",
    name: "procurement-committee-approvals",
    meta: {
      title: "Procurement Committee Approvals",
      authRequired: true,
      privileges: [],
    },
    component: () => import("@/views/committees/ProcurementCommitteesApprovals.vue"),
  },
  {
    path: '/procurement/manage-committee',
    name: 'manage-procurement-committee',
    meta: {
      title: "Procurement Committee",
      authRequired: true,
      privileges: [],
    },
    component: () => import("@/views/committees/ManageCommittee.vue"),
  },
  {
    path: '/procurement/approve-committee',
    name: 'approve-procurement-committee',
    meta: {
      title: "Procurement Committee",
      authRequired: true,
      privileges: [],
    },
    component: () => import("@/views/committees/ApproveProcurementCommittee.vue"),
  },

]
